import { render, staticRenderFns } from "./CreateOrderConfirmation.vue?vue&type=template&id=6bb9618c&scoped=true&"
import script from "./CreateOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./CreateOrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderConfirmation.vue?vue&type=style&index=0&id=6bb9618c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb9618c",
  null
  
)

export default component.exports